import { cloneElement } from 'react';
import { useMatchedRoute } from './lib/router';
import RequireAuth from './components/RequireAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import ResourceListPage from './components/ResourceListPage';
import { CONFIGS } from './resourceConfigs';
import { placesConfig } from './pages/places/placesConfig';
import PlaceDetailPage from './pages/places/PlaceDetailPage';
import ItinerariesPage from './pages/itineraries/ItinerariesPage';
import ItineraryDetailPage from './pages/itineraries/ItineraryDetailPage';
import FeedbackPage from './pages/feedback/FeedbackPage';
import NotificationsPage from './pages/notifications/NotificationsPage';
import ImageModerationPage from './pages/placeImages/ImageModerationPage';
import AllImagesPage from './pages/placeImages/AllImagesPage';
import DestinationModerationPage from './pages/destinations/DestinationModerationPage';
import PlaceActivityModerationPage from './pages/placeActivities/PlaceActivityModerationPage';
import HotelModerationPage from './pages/moderation/HotelModerationPage';
import RestaurantModerationPage from './pages/moderation/RestaurantModerationPage';
import LocationModerationPage from './pages/moderation/LocationModerationPage';
import './App.css';

// Flat config-driven list routes (food-preferences, group-types, states, tabs,
// pages, ads, activities, users, notifications).
const flatRoutes = Object.values(CONFIGS).map((cfg) => ({
  path: `/${cfg.key}`,
  element: <ResourceListPage config={cfg} />,
}));

const PROTECTED = [
  { path: '/', element: <ResourceListPage config={placesConfig} /> },
  // places + itineraries: list then detail (order doesn't matter, params disambiguate)
  { path: '/places', element: <ResourceListPage config={placesConfig} /> },
  { path: '/places/:id', element: <PlaceDetailPage /> },
  { path: '/itineraries', element: <ItinerariesPage /> },
  { path: '/itineraries/:id', element: <ItineraryDetailPage /> },
  { path: '/feedback', element: <FeedbackPage /> },
  { path: '/notifications', element: <NotificationsPage /> },
  { path: '/place-images', element: <ImageModerationPage /> },
  { path: '/all-images', element: <AllImagesPage /> },
  { path: '/moderate-destinations', element: <DestinationModerationPage /> },
  { path: '/place-activities', element: <PlaceActivityModerationPage /> },
  { path: '/hotels', element: <HotelModerationPage /> },
  { path: '/restaurants', element: <RestaurantModerationPage /> },
  { path: '/location', element: <LocationModerationPage /> },
  ...flatRoutes,
];

function App() {
  const publicRoute = useMatchedRoute([{ path: '/login', element: <Login /> }], null);
  const { element, params } = useMatchedRoute(PROTECTED, <NotFound />);

  if (publicRoute.element) return publicRoute.element;

  // Inject route params into the matched element (detail pages read `params`).
  const withParams = element ? cloneElement(element, { params }) : element;

  return (
    <RequireAuth>
      <Layout>{withParams}</Layout>
    </RequireAuth>
  );
}

export default App;
